import React from 'react';
import './Manifesto.scss';

const Manifesto: React.FC = () => {
  return (
    <section className="manifesto">
      <div className="container manifesto__inner">
        <p className="manifesto__label">Manifiesto</p>
        <div className="manifesto__body">
          <p>
            Codetrend es una <span className="gradient-text">empresa de productos</span> que
            crea software para personas.
          </p>
          <p>
            No perseguimos proyectos — los creamos. Cada producto que construimos es
            intencional, diseñado para la claridad, la usabilidad y el impacto real.
          </p>
          <p className="manifesto__mono">
            Elegimos qué construir. Trabajamos solo en ideas en las que creemos.
            Priorizamos el valor sobre el volumen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
